import FilterCheckList from "components/FilterCheckList";
import { useField } from "lib/form";
import React from "react";
import { useFilter } from "services/filter";
import { useCount } from "services/search";
import styled from "styled-components";

const Grid = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    gap: 16px;
`;

const names = {
    HANDMATIG: "Handgeschakeld",
    AUTOMATISCH: "Automaat"
};

export const TransmissieFilter = ({ condensed }) => {
    const filter = useFilter("transmissietype");
    const count = useCount("transmissietype");
    const [value, , onChange] = useField("transmissietypes");

    const options =
        filter.map((option) => ({
            id: option,
            displayName: names[option],
            aantal: count[option]
        })) || [];

    return (
        <Grid>
            <FilterCheckList
                filterId="filter-transmissie"
                dataTestId="filter-transmissie"
                options={options}
                value={value || []}
                handleChange={(_, v) => onChange(v)}
                columns={condensed ? 1 : 4}
                datalayerKey="transmissietype"
                maxSize={0}
            />
        </Grid>
    );
};
